export const STAND_SECTOR_ATTR = 'stand';
export const CATEGORY_ATTR = 'category';
